import { useTranslations } from 'next-intl';

type RecentSearchesProps = {
  searches: string[];
  onSearchClick: (searchTerm: string) => void;
};

function RecentSearches({ searches, onSearchClick }: RecentSearchesProps) {
  const t = useTranslations('general.search');

  const handleClick = (searchTerm: string) => {
    onSearchClick(searchTerm);
  };

  return (
    <div className="flex flex-col gap-6" data-testid="recent-searches" data-track-container="Recent Searches">
      <h3 className="paragraph-strong text-foreground-subtle" data-testid="recent-searches-title">
        {t('recent_searches')}
      </h3>
      <ul className="flex flex-col gap-5">
        {searches.map(searchTerm => (
          <li key={searchTerm} data-track-name={searchTerm}>
            <button
              type="button"
              onClick={() => handleClick(searchTerm)}
              className="flex flex-col gap-1 w-full text-left text-foreground"
              data-testid={`recent-search-item-${searchTerm}`}
            >
              <p className="paragraph-strong">{searchTerm}</p>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export { RecentSearches };
